import { render, staticRenderFns } from "./BoxActivitiesResults.vue.html?vue&type=template&id=3f72b0df&"
import script from "./BoxActivitiesResults.component.js?vue&type=script&lang=vueJs&"
export * from "./BoxActivitiesResults.component.js?vue&type=script&lang=vueJs&"
import style0 from "./BoxActivitiesResults.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports